import type {
  AccountlessNatalieEventApiResponse,
  NatalieEventDetail,
  NatalieEventDetailData,
  NatalieEventPublicDetail,
  NatalieEventPublicDetailData,
} from './natalieEvent.types';

export const mapNataliePublicEventDetailFromApi = ({
  id,
  communityId,
  endDate,
  name,
  topic,
  description,
  ownerName,
  communityName,
  status,
  logoImageLink,
  videoUrl,
  sessionDurationMinutes,
}: NatalieEventPublicDetailData): NatalieEventPublicDetail => ({
  id,
  communityId,
  endDate,
  name,
  topic,
  description,
  ownerName,
  communityName,
  status,
  logoImageLink,
  videoUrl,
  durationInMinutes: sessionDurationMinutes,
});

export const mapNatalieEventDetailFromApi = ({
  id,
  communityId,
  endDate,
  name,
  topic,
  description,
  ownerName,
  communityName,
  status,
  logoImageLink,
  sessionDurationMinutes,
  videoUrl,
}: NatalieEventDetailData): NatalieEventDetail => ({
  id,
  communityId,
  endDate,
  name,
  topic,
  description,
  ownerName,
  communityName,
  status,
  logoImageLink,
  durationInMinutes: sessionDurationMinutes,
  videoUrl,
});

export const mapAccountlessEventFromApi = (data: AccountlessNatalieEventApiResponse): NatalieEventPublicDetail => ({
  id: data.id,
  communityId: '',
  endDate: data.endDate,
  name: data.name,
  topic: data.topic,
  description: data.description ?? null,
  ownerName: data.ownerName ?? '',
  communityName: data.communityName ?? '',
  status: data.status,
  durationInMinutes: data.sessionDurationMinutes ?? 0,
  logoImageLink: data.logoImageLink ?? null,
  videoUrl: null,
});
